// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CtsGantryFunctionalUnitStepTileComponent } from '../cts-gantry-functional-unit-step-tile/cts-gantry-functional-unit-step-tile.component';
import { CtsGantryFunctionalUnitStep } from '../../interfaces/cts-gantry-functional-unit-step';

@Component({
  standalone: true,
  imports: [CommonModule, CtsGantryFunctionalUnitStepTileComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-functional-unit-step-list',
  templateUrl: './cts-gantry-functional-unit-step-list.component.html',
  styleUrl: './cts-gantry-functional-unit-step-list.component.scss',
})
export class CtsGantryFunctionalUnitStepListComponent {
  @Input({ required: true }) functionalUnit!: { [key: string]: string };
  @Input({ required: true }) stepsDefinition: CtsGantryFunctionalUnitStep[] =
    [];
}
